import { render, staticRenderFns } from "./TumblingsViewer.vue?vue&type=template&id=0aab619f&"
import script from "./TumblingsViewer.vue?vue&type=script&lang=js&"
export * from "./TumblingsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports